/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TimeOfDayResponse
 */
export interface TimeOfDayResponse {
    /**
     * 
     * @type {number}
     * @memberof TimeOfDayResponse
     */
    fromHours?: number;
    /**
     * 
     * @type {number}
     * @memberof TimeOfDayResponse
     */
    fromMinutes?: number;
    /**
     * 
     * @type {number}
     * @memberof TimeOfDayResponse
     */
    toHours?: number;
    /**
     * 
     * @type {number}
     * @memberof TimeOfDayResponse
     */
    toMinutes?: number;
}

export function TimeOfDayResponseFromJSON(json: any): TimeOfDayResponse {
    return TimeOfDayResponseFromJSONTyped(json, false);
}

export function TimeOfDayResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TimeOfDayResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'fromHours': !exists(json, 'fromHours') ? undefined : json['fromHours'],
        'fromMinutes': !exists(json, 'fromMinutes') ? undefined : json['fromMinutes'],
        'toHours': !exists(json, 'toHours') ? undefined : json['toHours'],
        'toMinutes': !exists(json, 'toMinutes') ? undefined : json['toMinutes'],
    };
}

export function TimeOfDayResponseToJSON(value?: TimeOfDayResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'fromHours': value.fromHours,
        'fromMinutes': value.fromMinutes,
        'toHours': value.toHours,
        'toMinutes': value.toMinutes,
    };
}


